/** Tab query values for the privileged photo admin route. */
export const PhotoAdminTabs = {
  UPLOAD: "upload",
  LIBRARY: "library",
};

/** In-memory upload session lifecycle. */
export const PhotoSessionStates = {
  IDLE: "idle",
  REVIEW: "review",
  RUNNING: "running",
  DONE: "done",
  CANCELLED: "cancelled",
};

/** Per-file queue row states. */
export const PhotoQueueItemStates = {
  QUEUED: "queued",
  UPLOADING: "uploading",
  UPLOADED: "uploaded",
  FAILED: "failed",
  SKIPPED: "skipped",
};

/** Allowed upload MIME types (must match main `PhotoContentTypes`). */
export const PhotoContentTypes = {
  JPEG: "image/jpeg",
  JPG: "image/jpg",
  PNG: "image/png",
  WEBP: "image/webp",
  GIF: "image/gif",
};

/** Lowercase extensions without a leading dot. */
export const PHOTO_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif"];

/** `accept` for the admin upload file input (ZIP or images). */
export const PHOTO_FILE_INPUT_ACCEPT =
  ".zip,image/jpeg,image/jpg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif";

/** Why a review row will not be uploaded. */
export const PhotoSkipReasons = {
  NOT_IMAGE: "notImage",
  DUPLICATE: "duplicate",
};

/** Czech labels for per-file queue row states. */
export const PhotoQueueItemStateLabels = {
  [PhotoQueueItemStates.QUEUED]: "Čeká",
  [PhotoQueueItemStates.UPLOADING]: "Nahrává se",
  [PhotoQueueItemStates.UPLOADED]: "Nahráno",
  [PhotoQueueItemStates.FAILED]: "Chyba",
  [PhotoQueueItemStates.SKIPPED]: "Přeskočeno",
};

/** Czech labels for review skip reasons (more specific than generic SKIPPED). */
export const PhotoSkipReasonLabels = {
  [PhotoSkipReasons.NOT_IMAGE]: "Přeskočeno",
  [PhotoSkipReasons.DUPLICATE]: "Už nahrané",
};

/** Photo processing lifecycle states (must match main). */
export const PhotoStates = {
  PENDING: "pending",
  PROCESSING: "processing",
  DONE: "done",
  FAILED: "failed",
};

/** Czech labels for photo processing states. */
export const PhotoStateLabels = {
  [PhotoStates.PENDING]: "Čeká",
  [PhotoStates.PROCESSING]: "Zpracování",
  [PhotoStates.DONE]: "Hotovo",
  [PhotoStates.FAILED]: "Chyba",
};

/** Filter options for the library grid state column. */
export const PHOTO_STATE_FILTER_OPTIONS = Object.values(PhotoStateLabels);

/** Client-side grid page size for `/gallery`. */
export const GALLERY_PAGE_SIZE = 24;

/** Gallery list sort: capture time only, or tags then capture time. */
export const GallerySortModes = {
  CAPTURED_TS: "capturedTs",
  TAGS: "tags",
};

/** Search-param keys for the user gallery route. */
export const GalleryQueryKeys = {
  ID: "id",
  TAGS: "tags",
  FROM: "from",
  SORT: "sort",
  PAGE: "page",
};

/** Czech chrome labels for `yet-another-react-lightbox` (keys match the package API). */
export const GalleryLightboxLabels = {
  Close: "Zavřít",
  Next: "Další",
  Previous: "Předchozí",
  Download: "Stáhnout",
  Share: "Sdílet",
  "Enter Fullscreen": "Celá obrazovka",
  "Exit Fullscreen": "Ukončit celou obrazovku",
  Play: "Přehrát",
  Pause: "Pozastavit",
  "Zoom in": "Přiblížit",
  "Zoom out": "Oddálit",
  Thumbnails: "Náhledy",
  "Show thumbnails": "Zobrazit náhledy",
  "Hide thumbnails": "Skrýt náhledy",
  Slide: "Snímek",
  Lightbox: "Fotogalerie",
  "Photo gallery": "Fotogalerie",
};
